import React, { useMemo } from 'react';
import countBy from 'lodash/countBy';
import withStyles from '@material-ui/core/styles/withStyles';
import Style from 'assets/jss/material-dashboard-pro-react/views/profileStyle.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import FavoriteGenresLabels from 'components/FavoriteGenresLabels';
import ImprintChart from 'components/ImprintChart';
import fyndaGenres from 'config/fyndaGenres';

export const UserImprintSimple = ({ classes, favoriteSongs }) => {
  // Add the genre for each track as defined by Fynda
  // and extract labels and datasets for the user imprint
  const { data, labels, backgroundColor } = useMemo(() => {
    const favorites = favoriteSongs.reduce((r, e) => {
      let i = 0;
      let fyndaGenre;
      const parentGenres = Object.keys(fyndaGenres);
      while (!fyndaGenre && parentGenres[i]) {
        const parentGenre = parentGenres[i];
        const { subgenres } = fyndaGenres[parentGenre];
        if (subgenres.includes(e.genre)) {
          fyndaGenre = parentGenre;
        }
        i++;
      }
      if (!fyndaGenre) return r;
      r.push({ ...e, fyndaGenre });
      return r;
    }, []);
    const countByGenre = countBy(favorites, (e) => e.fyndaGenre);
    const labels = Object.keys(countByGenre);
    const data = Object.values(countByGenre);
    const backgroundColor = labels.map((e) => fyndaGenres[e].color);
    return { data, labels, backgroundColor };
  });

  return (
    <div>
      <GridContainer
        className={classes.mobileAlbum}
        style={{
          width: '100%',
          padding: '20px 0px 0px 3%',
        }}
      >
        <GridItem xs={12}>
          <ImprintChart
            labels={labels}
            chartSize={300}
            datasets={[{ data, backgroundColor }]}
          />
        </GridItem>
      </GridContainer>
      <GridContainer
        className={classes.mobileAlbum}
        style={{
          width: '100%',
          padding: '30px 0px 0px 3%',
        }}
      >
        <FavoriteGenresLabels labels={labels} />
      </GridContainer>
    </div>
  );
};

export default withStyles(Style)(UserImprintSimple);
